import React, { useState } from "react";
import { Link as RouterLink, useParams, useLocation, useNavigate } from "react-router-dom";
// material
import { Table, TableRow, TableBody, TableCell, Box, CardContent, Container, Stack, Card, TextField, Button, TableContainer } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/Page";
import { AddPoolAction } from "../../redux/actions/MatchAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import Grid from "@mui/material/Unstable_Grid2";
import { Delete } from "@mui/icons-material";
import Loader from "src/components/Loader";
import { UserListHead } from "src/sections/@dashboard/user";
import { useEffect } from "react";

export default function PoolBreakPoint() {
    let { id, gametype } = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    let pooldata = location.state ? location.state.details : ""
    console.log("pooldata", pooldata)
    const loadingSelector = useSelector(state => state.matches.loading)
    const statusSelector = useSelector(state => state.matches.pool_status)
    const ContestListData = useSelector((state) => state.matches.pool_list.data);
    const poolCreatedSelector = useSelector(state => state.matches.pool_add)
    const [totalPercentage,setTotalPercentage]=useState(0);
    const [totalAmount,setTotalAmount]=useState(0);

    const [formValues, setFormValues] = useState([
        { pmin: "", pmax: "", pamount: "", eachamount: "", percentage: "", poolmaster_id: id },
    ]);

    let handleChange = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i][e.target.id] = e.target.value;
        let totalPer=0;
        let totalAmt=0;
       
        
        if (e.target.id === "percentage") {
            if (e.target.value > 100) {
                newFormValues[i]["percentage"] = "";
                newFormValues[i]["pamount"] = "";
                toast.error("Percentage is greater than 100%.")
            } else {
                newFormValues[i]["pamount"] = Math.round((pooldata.totalwinamt * e.target.value) / 100);
            }
        }

        newFormValues.map(item=>{
            totalPer=totalPer+ parseFloat(item.percentage?item.percentage:0);
            totalAmt=totalAmt+ parseFloat(item.pamount?item.pamount:0);
        })

        setTotalPercentage(totalPer);
        setTotalAmount(totalAmt);
        setFormValues(newFormValues);
    };

    let addFormFields = () => {
        let newFormValues = [...formValues];
        let chkBlankBefore=formValues[formValues.length-1]["pmin"];
        if(totalPercentage<100 && chkBlankBefore>0){
            
            // let i=formValues.length;

            console.log("eeeeee,totalPercentage--->>",totalPercentage)//,formValues,i,newFormValues[i-1])
            // newFormValues[i]["pmin"] = (newFormValues[i-1] && newFormValues[i-1]["pmax"])?parseInt(newFormValues[i-1]["pmax"])+1:1;
            setFormValues([
                ...formValues,
                { pmin: "", pmax: "", percentage: "", eachamount: "", pamount: "", poolmaster_id: id },
            ]);
        }
    };

    let removeFormFields = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues);
    };

    const submitContestFormData = (e) => {
        e.preventDefault();
        if (
            formValues.length == 0 ||
            formValues[0]?.pmin == "" ||
            formValues[0]?.pmax == "" ||
            formValues[0]?.pamount == ""
        ) {
            toast.error("All Filed Must be filled", { theme: "colored" });
        } else {
            let sendPoolData = {
                pool_prize_break_data: formValues,
            };
            dispatch(AddPoolAction(pooldata, sendPoolData));
        }
    };

    useEffect(() => {
        if (Object.keys(poolCreatedSelector).length > 0) {
            if (poolCreatedSelector.data.status) {
                let data = {
                    gtype: pooldata.gtype,
                    name: pooldata.name,
                    type: pooldata.type
                }
                navigate(`/dashboard/poollist/${pooldata.contest_id}/`, { state: data }, { replace: true });
            }
        }
    }, [poolCreatedSelector])
    return (
        <Page title="Pools">

            {/* {loadingSelector ? <Loader /> : null} */}

            <Container maxWidth="lg">
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                        <Grid xs={10}>
                            <HeaderBreadcrumbs
                                heading="Create Pool Contest"
                                links={[
                                    { name: "Dashboard", href: "/dashboard/app" },
                                    { name: "Contest List", href: "/dashboard/cricket/contest_list" },
                                    { name: "Pools" },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid lg={3}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span> Contest size :</span>
                                    <span style={{ marginLeft: 10 }}> <strong>{pooldata.maxteams}</strong> </span>
                                </div>
                            </Grid>

                            <Grid lg={3}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span> Winning price :</span>
                                    <span style={{ marginLeft: 10 }}> <strong> {pooldata.totalwinamt}  </strong></span>
                                </div>
                            </Grid>

                            <Grid lg={3}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span> Entry fee :</span>
                                    <span style={{ marginLeft: 10 }}> <strong> {pooldata.joinfee} </strong> </span>
                                </div>
                            </Grid>

                            <Grid lg={3}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span> Type :</span>
                                    <span style={{ marginLeft: 10 }}> <strong> {pooldata.gtype === "ckt" ? "Cricket" : "Football"} </strong> </span>
                                </div>
                            </Grid>
                        </Grid>

                        <TableContainer sx={{ marginTop: 2 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: 'c_no', label: '#', alignRight: false },
                                        { id: 'cs_rank', label: 'Start Rank', alignRight: false },
                                        { id: 'ce_rank', label: 'End Rank', alignRight: false },
                                        { id: 'c_percentage', label: 'Percentage', alignRight: false },
                                        // { id: 'c_each_price', label: 'Each price', alignRight: false },
                                        { id: 'c_total_price', label: 'Total Amount', alignRight: false },
                                        { id: 'c_action', label: 'Action', alignRight: false }
                                    ]}
                                />
                                <TableBody>
                                    {formValues.map((element, index) => {
                                        return (
                                            <TableRow key={index} >
                                                <TableCell component="th" scope="row">
                                                    {(index + 1)}.
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        required
                                                        type="number"
                                                        onChange={(e) => handleChange(index, e)}
                                                        value={element.pmin || ""}
                                                        id="pmin"
                                                        label="Min"
                                                        fullWidth
                                                        variant="outlined"
                                                    />
                                                </TableCell>

                                                <TableCell>
                                                    <TextField
                                                        required
                                                        id="pmax"
                                                        type="number"
                                                        onChange={(e) => handleChange(index, e)}
                                                        value={element.pmax || ""}
                                                        label="Max"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        required
                                                        id="percentage"
                                                        type="text"
                                                        onChange={(e) => handleChange(index, e)}
                                                        value={element.percentage || ""}
                                                        label="Percentage"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        required
                                                        id="pamount"
                                                        type="number"
                                                        onChange={(e) => handleChange(index, e)}
                                                        value={element.pamount || ""}
                                                        label="Amount"
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled
                                                    />
                                                </TableCell>
                                                {/* <TableCell>
                                                    <TextField
                                                        type="number"
                                                        onChange={(e) => handleChange(index, e)}
                                                        value={element.pamount || ""}
                                                        label="Total price"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </TableCell> */}
                                                <TableCell>
                                                    {index !== 0 &&
                                                        <Button
                                                            align={"center"}
                                                            onClick={() => removeFormFields(index)}
                                                            variant="contained"
                                                            fullWidth
                                                            color="error"
                                                        >
                                                            <Delete />
                                                        </Button>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>{totalPercentage}</TableCell>
                                        <TableCell>{totalAmount}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>


                        <div style={{ marginTop: 30, marginBottom: 30 }}>
                            <Grid container spacing={2}>
                                <Grid xs={12}>
                                    <div align="right">
                                        <Button
                                            onClick={() => addFormFields()}
                                            variant="contained"
                                            color="success"
                                        > Add row </Button>
                                    </div>
                                </Grid>
                            </Grid>

                            <Button
                                variant="contained"
                                onClick={(e) => submitContestFormData(e)}
                            >
                                Add Pool
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </Container>
        </Page>
    );
}